import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserInfo } from '../../App/selectors'
import { actions } from '../reducer'
import { ProfileAccountTypes, ProfileFormValues } from '../types'
import { getProfileForm } from '../selectors'

export const useCallbacks = () => {
  const dispatch = useDispatch()
  const [blured, setBlured] = React.useState<Record<string, boolean>>({})
  const profileForm = useSelector(getProfileForm)
  const userInfo = useSelector(getUserInfo)

  return {
    onBlured: React.useCallback(
      (prop: string) => {
        setBlured((prev) => ({ ...prev, ...{ [prop]: true } }))
      },
      [setBlured]
    ),
    onReset: React.useCallback(() => {
      setBlured({})
      if (userInfo?.email) {
        dispatch(
          actions.onProfileForm({ ...ProfileFormValues, email: userInfo.email })
        )
      }
    }, [setBlured, dispatch, userInfo]),
    onChange: React.useCallback(
      (e: React.ChangeEvent<{ value: unknown }>, prop: string) => {
        dispatch(
          actions.onProfileForm({ ...profileForm, [prop]: e.target.value })
        )
      },
      [profileForm, dispatch]
    ),
    onIsAchDebit: React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = (event.target as HTMLInputElement).value
        if (!val) return
        if (val === ProfileAccountTypes.BANK_ACCOUNT) {
          dispatch(actions.onProfileForm({ ...profileForm, cardNumber: '' }))
          dispatch(actions.onProfileForm({ ...profileForm, cardCode: '' }))
          dispatch(
            actions.onProfileForm({ ...profileForm, expirationDate: '' })
          )
          dispatch(actions.onIsAchDebit(true))
        } else {
          dispatch(actions.onProfileForm({ ...profileForm, nameOnAccount: '' }))
          dispatch(actions.onProfileForm({ ...profileForm, accountNumber: '' }))
          dispatch(actions.onProfileForm({ ...profileForm, routingNumber: '' }))
          dispatch(actions.onIsAchDebit(false))
        }
      },
      [dispatch, profileForm]
    ),
    blured,
  }
}
